export const publicVersion = "2.5.1-0-g91ecfcbd-2026-03-05T15-13-27Z";